import {styled} from "@mui/material/styles"
import {SimplifiedButton} from "../../../horizontalFilters/facetListBox/components"

export const Cashmere25HFMoreLessButton = styled(SimplifiedButton)`
    && {
        color: ${({theme}) => theme.colours.light.text.primary};
        background-color: ${({theme}) => theme.colours.utilities.background.paper};
        font-family: ${({theme}) =>
            `${theme.colours.component.buttonMedium.fontFamily}, ${theme.colours.font.default}`};
        font-weight: ${({theme}) => `${theme.colours.component.buttonMedium.fontWeight}`};
        font-size: ${({theme}) => `${theme.colours.component.buttonMedium.fontSize}`};
        text-transform: uppercase;
        padding-left: 0.5rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        max-width: 70%;
        letter-spacing: ${({theme}) => `${theme.colours.typography.body3.letterSpacing}`};
    }
`
export default Cashmere25HFMoreLessButton
